export enum LocalStorageKey {
    U = 'u',
    StaticLookup = 'staticLookup',
    Country = 'country',
}

export enum ClaimCategories {
    Motor = 'motor',
    GlassOnly = 'glassOnly',
}
